'use strict';

import {
	initPhotoSwipe
} from "~/public/utilities/utilities";

/**
 * For recent reviews shortcode js.
 */
var recentReviews = {
	init: function() {
		this.renderPhotoSwipeContainer()
		initPhotoSwipe('#recentCustReviews .reviewImg');
		$('#recentCustReviews .reviewVideoThumbnail').click(this.reviewVideo);
	},
	reviewVideo: function() {
		let iframeSrc = $(this).closest('.reviewImageInnerContainer')
			.find('input[type=hidden]').val();

		$.fancybox({
			type: 'iframe',
			href: iframeSrc,
			fitToView: true
		});
	},
	renderPhotoSwipeContainer: function() {
		let html = `
			<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true" style="z-index: 11111;">
				<div class="pswp__bg"></div>
				<div class="pswp__scroll-wrap">
					<div class="pswp__container">
					<div class="pswp__item"></div>
					<div class="pswp__item"></div>
					<div class="pswp__item"></div>
				</div>
				<div class="pswp__ui pswp__ui--hidden">
					<div class="pswp__top-bar">
						<div class="pswp__counter"></div>
						<button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
						<button class="pswp__button pswp__button--share" title="Share"></button>
						<button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
						<button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
						<div class="pswp__preloader">
							<div class="pswp__preloader__icn">
								<div class="pswp__preloader__cut">
									<div class="pswp__preloader__donut"></div>
								</div>
							</div>
						</div>
					</div>
					<div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
						<div class="pswp__share-tooltip"></div>
					</div>
					<button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>
					<button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>
					<div class="pswp__caption">
						<div class="pswp__caption__center"></div>
						</div>
					</div>
				</div>
			</div>
		`;

		$(document.body).append(html);
	}
};

window.recentReviews = recentReviews;

// DOM ready
$(function() {
	recentReviews.init();
});